module.exports = __webpack_public_path__ + "img/mobileintegrated1.e7902171.png";